import React from "react";
import styles from "./styles.module.scss";
import { getStatusBadgeContent } from "../../utils/status";

const ShippingCard = ({ shipment, onClick, isSelected }) => {
  const badge = getStatusBadgeContent(shipment?.status);

  return (
    <div
      className={`${styles.shipping_card} ${isSelected ? styles.selected : ""}`}
      onClick={onClick}
    >
      <div className={styles.card_left}>
        <div className={styles.card_content}>
          <div className={styles.dba_name}>{shipment?.dba || "-"}</div>
          <div className={styles.ship_to}>ship to {shipment?.ship_to || "-"}</div>
        </div>
      </div>
      <div className={styles.card_right}>
        <div className={`${styles.status_dot} ${styles[badge.variant]}`} />
        <span className={styles.status_text}>{badge.text}</span>
      </div>
    </div>
  );
};

export default ShippingCard;
